import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { EnvBanner } from "@blog/spa-common/components/EnvBanner";
import { CLIENT_BUILD } from "./lib/api";
import "./index.css";

// Referenciar el marcador impide que se elimine por tree-shaking: si se
// eliminara, cambiarlo no alteraría el bundle y no habría forma de forzar
// hashes nuevos tras un deploy parcial. Ver lib/api.ts.
document.documentElement.dataset.build = CLIENT_BUILD;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    {/* Vacío en producción (VITE_ENV_LABEL sin definir en .env.production). */}
    <EnvBanner label={import.meta.env.VITE_ENV_LABEL} />
  </React.StrictMode>,
);
